import { useState, useEffect } from 'react';
import { AlertCircle, Home, RefreshCw, ArrowLeft } from 'lucide-react';

function Error({ error, pageName, pageLink, navigate }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const handleButtonClick = () => {
        if (navigate) {
            navigate(pageLink);
        } else if (pageLink) {
            window.location.href = pageLink;
        }
    };

    const handleRefresh = () => {
        window.location.reload();
    };

    const handleGoHome = () => {
        if (navigate) {
            navigate('/');
        } else {
            window.location.href = '/';
        }
    };

    return (
        <div className="w-full h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
            <div 
                className={`max-w-md w-full transition-all duration-700 transform ${
                    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
            >
                <div className="flex justify-center mb-6">
                    <div className="relative">
                        <div className="absolute inset-0 bg-red-500 rounded-full opacity-20 animate-ping"></div>
                        <div className="relative bg-red-100 rounded-full p-4">
                            <AlertCircle className="w-12 h-12 text-red-600" strokeWidth={2} />
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                    <div className="text-center space-y-2">
                        <h1 className="text-2xl font-bold text-slate-900">
                            Oops! Something went wrong
                        </h1>
                        <p className="text-slate-600 leading-relaxed">
                            {error || "We encountered an unexpected error. Don't worry, it's not your fault."}
                        </p>
                    </div>

                    <div className="space-y-3">
                        {(pageLink || pageName) && (
                            <button
                                onClick={handleButtonClick}
                                className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl"
                            >
                                <ArrowLeft className="w-5 h-5" strokeWidth={2} />
                                Back to {pageName || 'Previous Page'}
                            </button>
                        )}

                        <div className="grid grid-cols-2 gap-3">
                            <button
                                onClick={handleRefresh}
                                className="flex items-center justify-center gap-2 px-4 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium rounded-lg transition-all duration-200 hover:shadow-md"
                            >
                                <RefreshCw className="w-4 h-4" strokeWidth={2} />
                                Refresh
                            </button>
                            <button
                                onClick={handleGoHome}
                                className="flex items-center justify-center gap-2 px-4 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium rounded-lg transition-all duration-200 hover:shadow-md"
                            >
                                <Home className="w-4 h-4" strokeWidth={2} />
                                Home
                            </button>
                        </div>
                    </div>

                    <div className="pt-4 border-t border-slate-200">
                        <p className="text-sm text-slate-500 text-center">
                            If this problem persists, please contact <a href="mailto:xenie.support@branchx.in" className='text-link hover:underline'>support</a>
                        </p>
                    </div>
                </div>

                <div className="mt-6 flex justify-center gap-2">
                    <div className="w-2 h-2 bg-slate-300 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                    <div className="w-2 h-2 bg-slate-300 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                    <div className="w-2 h-2 bg-slate-300 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                </div>
            </div>
        </div>
    );
}

export default Error;
